import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function GiveawayPage() {
  useEffect(() => {
    // Load KingSumo script
    const script = document.createElement('script');
    script.src = 'https://kingsumo.com/js/embed.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-black text-white">
      {/* Header */}
      <header className="border-b border-zinc-900">
        <div className="max-w-7xl mx-auto px-6 py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity cursor-pointer">
            <i className="ri-arrow-left-line text-2xl text-red-500 w-6 h-6 flex items-center justify-center"></i>
            <span className="text-white font-bold text-lg tracking-wider">BACK TO HOME</span>
          </Link>
          
          <div className="flex items-center gap-2">
            <i className="ri-gift-line text-2xl text-red-500 w-6 h-6 flex items-center justify-center"></i>
            <span className="text-red-500 font-bold text-sm tracking-widest uppercase">Limited Time</span>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-5xl mx-auto px-6 py-12 md:py-20">
        {/* Hero Section */}
        <div className="text-center mb-12">
          <div className="inline-block mb-6">
            <div className="flex items-center gap-3 px-6 py-3 border-2 border-red-600 bg-red-600/10">
              <i className="ri-gift-line text-3xl text-red-500 w-8 h-8 flex items-center justify-center"></i>
              <span className="text-red-500 font-bold text-lg tracking-widest uppercase">Limited Time Giveaway</span>
            </div>
          </div>

          <h1 className="text-5xl md:text-7xl font-black text-white mb-6 uppercase tracking-tight">
            12 DREAM GETAWAYS
          </h1>
          
          <div className="max-w-3xl mx-auto mb-10">
            <p className="text-2xl md:text-3xl font-light text-red-500 mb-6 tracking-wide">
              CELEBRATING CHICAGO HEARTBREAK
            </p>
            <p className="text-lg md:text-xl text-gray-300 leading-relaxed mb-4">
              Enter for your chance to win an all-expenses-paid <strong className="text-white">4 days and 3 nights vacation stay</strong> to <strong className="text-white">New York City</strong>, <strong className="text-white">Las Vegas</strong>, or <strong className="text-white">Miami</strong>. Winner's choice. 12 lucky winners will be selected.
            </p>
            <p className="text-base text-gray-400">
              *Winner is responsible for flights, vacation stay taxes, and fees.
            </p>
          </div>

          {/* Destinations */}
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            <div className="flex items-center gap-3 px-6 py-3 bg-zinc-900 border-2 border-red-600">
              <i className="ri-building-line text-red-500 text-2xl w-6 h-6 flex items-center justify-center"></i>
              <span className="text-white font-bold tracking-wider text-lg">NEW YORK CITY</span>
            </div>
            <div className="flex items-center gap-3 px-6 py-3 bg-zinc-900 border-2 border-red-600">
              <i className="ri-casino-line text-red-500 text-2xl w-6 h-6 flex items-center justify-center"></i>
              <span className="text-white font-bold tracking-wider text-lg">LAS VEGAS</span>
            </div>
            <div className="flex items-center gap-3 px-6 py-3 bg-zinc-900 border-2 border-red-600">
              <i className="ri-sun-line text-red-500 text-2xl w-6 h-6 flex items-center justify-center"></i>
              <span className="text-white font-bold tracking-wider text-lg">MIAMI</span>
            </div>
          </div>
        </div>

        {/* KingSumo Embed */}
        <div className="bg-black p-8 md:p-12 min-h-[500px] mb-8">
          <div id="kingsumo-embed" data-url="https://kingsumo.com/g/mpjv4lm/12-dream-getaways-giveaway"></div>
        </div>

        {/* Fine Print */}
        <div className="text-center">
          <p className="text-gray-500 text-sm leading-relaxed max-w-2xl mx-auto">
            *Winner is responsible for flights, vacation stay taxes, and fees. No purchase necessary. See official rules for details. This giveaway is celebrating the release of Chicago Heartbreak by E.T.C.
          </p>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-zinc-900 mt-20">
        <div className="max-w-7xl mx-auto px-6 py-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
              © 2025 E.T.C. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link to="/privacy-policy" className="text-gray-500 hover:text-red-500 transition-colors text-sm cursor-pointer">
                Privacy Policy
              </Link>
              <Link to="/terms-of-service" className="text-gray-500 hover:text-red-500 transition-colors text-sm cursor-pointer">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
